import React, { useRef } from 'react'

import { Icon } from 'src/components/ui'
import type { ReferralType } from 'src/pages/ListOfReferrals/ListOfReferrals.types'

import styles from './ReferralsList.module.scss'

const ReferralsList = ({ referralsList, className }: { referralsList: Array<ReferralType>; className?: string }) => {
  const itemRef = useRef<HTMLLIElement | null>(null)

  return (
    <ul className={`${styles.list} ${className}`}>
      {referralsList.map((referral) => {
        const { ReferalUser, id, income_stars } = referral ?? {}

        if (ReferalUser?.username.length > 26) {
          ReferalUser.username = `${ReferalUser.username.slice(0, 26)}...`
        }

        return (
          <li ref={itemRef} key={id} className={styles.item}>
            <p className={styles.item_name}>{ReferalUser?.username}</p>
            <div className={styles.item_amount}>
              <p>+ {income_stars}</p>
              <Icon name='referralStar' />
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default ReferralsList
